var _g, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgCircleCheck(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    viewBox: "0 0 14 14",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg"
  }, props), _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#circle-check_svg__clip0_31_3058)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M10.073 5.004a.538.538 0 010 .762L6.304 9.535a.538.538 0 01-.762 0L3.927 7.919a.539.539 0 01.762-.761l1.234 1.235 3.388-3.39a.539.539 0 01.762 0zM14 7a7 7 0 11-7-7 7.007 7.007 0 017 7zm-1.077 0A5.923 5.923 0 107 12.923 5.93 5.93 0 0012.923 7z"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "circle-check_svg__clip0_31_3058"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M0 0h14v14H0z"
  })))));
}
export default SvgCircleCheck;